export default __webpack_public_path__ + "static/media/terms.04ddbc65.pdf";